import { ref } from "vue";
import firebase from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import defaultDoctorImage from "../assets/images/user/05.jpg";

const getDoctors = () => {
  const doctor = ref(null);

  const loadDoctor = async () => {
    try {
      const doctorRef = doc(
        firebase.db,
        "doctors",
        firebase.firebaseAuth.currentUser.uid
      );
      const doctorSnap = await getDoc(doctorRef);

      if (doctorSnap.exists) {
        const data = doctorSnap.data();
        if (data.profilePic) {
          doctor.value = data;
        } else {
          doctor.value = { ...data, profilePic: defaultDoctorImage };
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  return { doctor, loadDoctor };
};
export default getDoctors;
